const SharingPermissionTerms = {
  NONE: "none",
  READ: "read",
  WRITE: "write",
} as const;

export default SharingPermissionTerms;
